export const SEAT_PROPERTIES = {
  TV: 'tv',
  PLUG: 'plug',
  WOMEN: 'women'
}

export const WC_PROPERTIES = {
  WOMEN: 'women',
  MEN: 'men'
}
